import tw from "twin.macro";
import { styled } from "~/config/stitches";

const CheckboxGroupWrapper = styled("fieldset", {
  ...tw`w-full`,
});

export { CheckboxGroupWrapper };
